"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _RequiredQuestionTypeComponent = _interopRequireDefault(require("./RequiredQuestionTypeComponent"));
function RequiredQuestionTypeComponentList(_ref) {
  var questions = _ref.questions,
    prePopulate = _ref.prePopulate;
  return questions.map(function (question) {
    var questionId = question.questionId;
    var _ref2 = prePopulate[questionId] || {},
      value = _ref2.value;
    return /*#__PURE__*/_react["default"].createElement(_RequiredQuestionTypeComponent["default"], {
      key: questionId,
      question: question,
      prePopulatedValue: value || ''
    });
  });
}
RequiredQuestionTypeComponentList.propTypes = {
  questions: _propTypes["default"].array.isRequired,
  prePopulate: _propTypes["default"].object.isRequired
};
var _default = exports["default"] = RequiredQuestionTypeComponentList;
//# sourceMappingURL=RequiredQuestionTypeComponentList.js.map